import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Infos sur les virements',
    payouts: 'Virements',
  },
  form: {
    invoicing_emails: {
      label: 'Envoyer les factures à',
      placeholder: 'Saisir votre e-mail',
    },
    payout_schedule: {
      label: 'Calendrier des virements',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Virements suspendus',
        [PAYOUT_INTERVAL.DAILY]: 'Virements quotidiens',
        [PAYOUT_INTERVAL.WEEKLY]: 'Virements hebdomadaires',
        [PAYOUT_INTERVAL.MONTHLY]: 'Virements mensuels',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    amount: 'Montant',
    cash_amount: 'Montant en espèces',
    paypal_standalone_amount: 'Montant PayPal',
    period: 'Période',
    paid_at: 'Payé le',
    provider: 'Fournisseur',
    status: 'Statut',
    actions: 'Actions',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Espèces',
    system: 'Système',
  },
  buttons: {
    save: 'Enregistrer',
    actions: 'Actions',
    open_report: 'Ouvrir le rapport',
    open_tracking_url: 'Suivre le versement',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'En attente',
    [PAYOUT_STATUSES.processing]: 'En cours',
    [PAYOUT_STATUSES.paid]: 'Payé',
    [PAYOUT_STATUSES.failed]: 'Échoué',
    undefined: 'Inconnu',
    null: 'Inconnu',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    successfully_updated: 'Mise à jour réussie',
  },
};
